import { breakpoints, mediaQueries, mq, multipliers, viewportsArray } from './foundation/breakpoints';
import colors from './foundation/colors';
import fonts from './foundation/fonts';
import animation from './foundation/animation';
import buttons from './foundation/buttons';
import typography from './foundation/typography';
import layout from './foundation/layout';
import focus from './foundation/focus';
import { spaces } from './foundation/spaces';
import radius from './foundation/radius';
import { expandVariants, normalizeStyles } from './utils';
export var theme = {
  animation: animation,
  breakpoints: breakpoints,
  buttons: buttons,
  colors: colors,
  disableScaling: false,
  expandVariants: expandVariants,
  focus: focus,
  fonts: fonts,
  layout: layout,
  mediaQueries: mediaQueries,
  mq: mq,
  multipliers: multipliers,
  normalizeStyles: normalizeStyles,
  radius: radius,
  spaces: spaces,
  typography: typography,
  viewportsArray: viewportsArray
};